<template>
  <section id="dashboard-analytics">
    <b-row class="match-height">
      <b-col
        lg="4"
        md="12"
      >
        <EcommerceStatistics />
      </b-col>

      <b-col
        lg="4"
        md="12"
      >
        <ticketReport />
      </b-col>

      <b-col
        lg="4"
        md="12"
      >
        <div class="d-flex flex-column">
          <div>
            <allUsersReport />
          </div>
          <div>
            <earningCurrentMonth />
          </div>
        </div>
      </b-col>

      <b-col
        lg="12"
        md="12"
      >
        <SellReport />
      </b-col>

    </b-row>
  </section>
</template>

<script>
import allUsersReport from './allUsersReport.vue'
import earningCurrentMonth from './earningCurrentMonth.vue'
import EcommerceStatistics from './EcommerceStatistics.vue'
import SellReport from './sellReport.vue'
import ticketReport from './ticketReport.vue'

export default {
  name: 'Dashboard',
  components: {
    allUsersReport,
    SellReport,
    EcommerceStatistics,
    earningCurrentMonth,
    ticketReport,
  },
  data() {
    return {
      data: {},
    }
  },
}
</script>
